import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "selected-freelancer-list joy-panel" }
const _hoisted_2 = { slot: "user-card-free-slot" }
const _hoisted_3 = {
  key: 1,
  "data-testid": "selected-freelancer-list_recommendation"
}
const _hoisted_4 = {
  key: 2,
  class: "selected-freelancer-list__footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_freelancer_price = _resolveComponent("freelancer-price")!
  const _component_joy_badge_level = _resolveComponent("joy-badge-level")!
  const _component_joy_rating_stars = _resolveComponent("joy-rating-stars")!
  const _component_joy_user_card = _resolveComponent("joy-user-card")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.freelancers, (freelancer, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "joy-panel__section"
      }, [
        _createVNode(_component_joy_user_card, {
          "photo-url": freelancer.photoUrl,
          "full-name": freelancer.fullName,
          "sub-title": freelancer.headline
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_freelancer_price, {
                profile: freelancer,
                "with-tooltips": _ctx.freelancers.length > 1
              }, null, 8, ["profile", "with-tooltips"]),
              (freelancer.malterLevels.length)
                ? (_openBlock(), _createBlock(_component_joy_badge_level, {
                    key: 0,
                    type: "supermalter",
                    "super-malter-level": freelancer.malterLevels.length
                  }, null, 8, ["super-malter-level"]))
                : _createCommentVNode("", true),
              (freelancer.recommendationsCount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_joy_rating_stars, {
                      "rating-value": freelancer.ratings
                    }, null, 8, ["rating-value"]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.getRecommendationText(freelancer.recommendationsCount)), 1)
                  ]))
                : _createCommentVNode("", true),
              (freelancer.avgAnsweringTime)
                ? (_openBlock(), _createElementBlock("footer", _hoisted_4, [
                    _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getAvgAnsweringTime(freelancer)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 2
        }, 1032, ["photo-url", "full-name", "sub-title"])
      ]))
    }), 128))
  ]))
}